import { render, staticRenderFns } from "./popup_auditorium.vue?vue&type=template&id=b6b992c0&"
import script from "./popup_auditorium.vue?vue&type=script&lang=js&"
export * from "./popup_auditorium.vue?vue&type=script&lang=js&"
import style0 from "./popup_auditorium.vue?vue&type=style&index=0&id=b6b992c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LiveChat: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/live_chat.vue').default,LivePolling: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/live_polling.vue').default,PopupModal: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_modal.vue').default,PopupSurvey: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/popup_survey.vue').default})
